<template>
  <span @click="fnClick(data.text)" @mouseover="fnHoverMessage(data.text)" @mouseleave="fnClearHoverMessage"
    ><el-tag class="tag-green" >{{ data.textShow }}</el-tag>
  </span>
</template>

<script>
import { Tag, Form, Button, Tooltip, Popover } from 'element-ui';

export default {
  name: 'MassageSuggest',
  props: ['data'],
  data() {
    return {};
  },
  components: {
    [Tag.name]: Tag,
    [Form.name]: Form,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip,
    [Popover.name]: Popover,
  },
  methods: {
    fnClick(item) {
      this.$emit('messageSuggest', item);
    },
    fnHoverMessage(item) {
      this.$emit('hoverMessage', item);
    },
    fnClearHoverMessage() {
      this.$emit('hoverMessage', null);
    },
  },
};
</script>
<style>
span.el-tag.tag-green {
  cursor: pointer;
  padding: 0 12px;
  height: 40px;
  line-height: 38px;
  font-size: 20px;
  margin-bottom: 8px;
  margin-right: 5px;
  background: #00978bd4;
  color: #fff;
  width: 190px;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/components/MassageSuggest.vue